export default function cookieInit() {
    class GradeSearchCookie {
        constructor() {
            this.cookieName = 'ake_bnstop';
            this.cookieValue = this.getCookie(); // コンストラクターでクッキーを取得
        }

        // クッキーを設定する
        setCookie(hours = 24) {
            var expires = "";
            var date = new Date();
            date.setHours(date.getHours() + hours); // 現在時刻から指定した時間後の時刻を設定
            expires = "; expires=" + date.toUTCString();
            document.cookie = this.cookieName + "=true" + expires + "; path=/";
        }

        // クッキーから値を取得する
        getCookie() {
            var nameEQ = this.cookieName + "=";
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i];
                while (cookie.charAt(0) === ' ') {
                    cookie = cookie.substring(1, cookie.length);
                }
                if (cookie.indexOf(nameEQ) === 0) {
                    return cookie.substring(nameEQ.length, cookie.length);
                }
            }
            return null;
        }

        // クッキーを削除する
        deleteCookie() {
            document.cookie = this.cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            this.cookieValue = null; // クッキー値をnullに設定
        }

        // クッキーが期限切れかどうかを確認し、削除する
        checkAndDeleteExpiredCookie() {
            var savedTime = this.getCookie();
            if (savedTime) {
                var savedDate = new Date(savedTime);
                if (Date.now() > savedDate.getTime()) { // 保存された日時が現在時刻より過去であれば
                    this.deleteCookie(); // クッキーを削除
                }
            }
        }
    }

    // 新しいGradeSearchCookieインスタンスを作成
    var visitCookie = new GradeSearchCookie();

    // 期限切れのクッキーを定期的に削除する
    visitCookie.checkAndDeleteExpiredCookie();

    return visitCookie; // インスタンスを返す
}
